import { Box, Stack } from "@mzc-pdc/ui";
import Skeleton from "@components_v2/skeleton/skeleton";
import theme from "@styles/theme";

export const NotifyItemSkeleton = () => {
    return (
        <Stack
            direction="row"
            sx={{
                width: "100%",
                gap: theme.spacing(1.5),
                p: theme.spacing(2.5),
                borderBottom: `1px solid ${theme.palette.greySecondary[100]}`,
            }}
        >
            <Stack direction="row" gap={theme.spacing(1.5)} sx={{ flex: 1 }}>
                {/* 아바타 영역 */}
                <Box sx={{ flexShrink: 0 }}>
                    <Skeleton variant="circular" animation="wave" width={28} height={28} />
                </Box>

                {/* 메시지 영역 */}
                <Stack direction="column" gap={theme.spacing(1)} sx={{ flex: 1 }}>
                    {/* 이름 + 메시지 + 시간 */}
                    <Stack direction="row" justifyContent="space-between" gap={theme.spacing(1)}>
                        <Stack direction="row" gap={theme.spacing(0.75)} sx={{ flex: 1 }}>
                            <Skeleton variant="rounded" animation="wave" width={60} height={22} />
                            <Box sx={{ flex: 1 }}>
                                <Skeleton variant="rounded" animation="wave" height={20} sx={{ width: "100%" }} />
                            </Box>
                        </Stack>
                        <Skeleton variant="rounded" animation="wave" width={90} height={18} />
                    </Stack>

                    {/* 프로젝트 */}
                    <Skeleton variant="rounded" animation="wave" width={180} height={17} />

                    {/* 배지/리소스 */}
                    <Skeleton variant="rounded" animation="wave" width={320} height={17} />
                </Stack>
            </Stack>

            {/* 우측 버튼 */}
            <Box sx={{ flexShrink: 0, flexBasis: "20px", display: "flex", alignItems: "center" }}>
                <Skeleton variant="circular" animation="wave" width={20} height={20} />
            </Box>
        </Stack>
    );
};
